class MainPDP extends HTMLElement {
	constructor() {
		super();
		this.SELECTORS = {
			DOC_BODY: 'body',
			variantOptionSelectors: '.custom-dropdown__wrapper',
			variantOptions: '.custom-dropdown__option-selector .option_value:not(.more-sizes)',
			accordionToggles: '.main-pdp__accordion-item .accordion-header',
			productFormCTA: '#productFormCTA',
			enquireButton: '.enquiery-oos',
			variantIdSelectReference: '#VariantIdSelectReference',
			selectedOptions: '[data-selected-option]',
			variantHiddenInput: 'input[name="id"], .product-variant-id',
			stockStatus: '.main-pdp__product-form .stock-status'
		};
		this.variantSelected = null;
	}

	connectedCallback() {
		// console.log('load main-pdp');
		this.bindEvents();
		this.parseAccordionJSON();
		this.initSingleVariantProduct();
		this.initGalleryPagination();
	}

	bindEvents() {
		this.optionSelectorToggle();
		this.optionClickHandler();
		this.accordionClickHandler();
		this.watchStrapSizeHandler();

	}

	getElement(selectorKey) {
		return this.querySelector(this.SELECTORS[selectorKey]);
	}

	// Helper method to get all matching elements
	getElements(selectorKey) {
		return this.querySelectorAll(this.SELECTORS[selectorKey]);
	}

	optionSelectorToggle() {
		const optionToggles = this.getElements('variantOptionSelectors');
		optionToggles?.forEach(optionToggle => {
			optionToggle?.addEventListener('click', (e) => {
				e.preventDefault();
				if (optionToggle.classList.contains('expanded')) {
					optionToggle.classList.remove('expanded');
				} else {
					optionToggle.classList.add('expanded');
				}
			});
		});
	}

	optionClickHandler() {
		const optionButtons = this.getElements('variantOptions');
		optionButtons?.forEach(optionBtn => {
			optionBtn?.addEventListener('click', (e) => {
				e.preventDefault();
				const optionWrapper = optionBtn.parentNode.parentNode;
				const thisSelectedOption = optionWrapper.querySelector('div[data-selected-option]');
				const thisValue = optionBtn.getAttribute('data-value');
				const optionType = optionWrapper.getAttribute('data-option-type');

				if (thisSelectedOption) {
					thisSelectedOption.setAttribute('data-selected-option', thisValue);
					thisSelectedOption.innerHTML = thisValue;

					this.checkVariantSelected();

				}
			});
		})
	}

	watchStrapSizeHandler() {
		const watchStrapSelector = this.querySelector('[data-watch-strap-size-selector]');
		if (!watchStrapSelector) {
			return;
		}

		const strapSizeOptions = watchStrapSelector.querySelectorAll('.option_value');
		const strapSizeInput = this.querySelector('.watch-strap-size-input');

		if (!strapSizeInput) {
			return;
		}

		// Check initial state on load
		this.checkWatchStrapSizeButton();

		strapSizeOptions?.forEach(optionBtn => {
			optionBtn?.addEventListener('click', (e) => {
				e.preventDefault();
				const selectedValue = optionBtn.getAttribute('data-value');
				const thisSelectedOption = watchStrapSelector.querySelector('div[data-selected-option]');

				if (thisSelectedOption && selectedValue) {
					thisSelectedOption.setAttribute('data-selected-option', selectedValue);
					thisSelectedOption.innerHTML = selectedValue;
					strapSizeInput.value = selectedValue;
					// Update button state after selection
					this.checkWatchStrapSizeButton();
				}
			});
		});
	}

	checkWatchStrapSizeButton() {
		const strapSizeInput = this.querySelector('.watch-strap-size-input');
		if (!strapSizeInput) {
			return;
		}

		const productFormCTA = this.getElement('productFormCTA');
		const enquireButton = this.getElement('enquireButton');
		const submitButtonText = productFormCTA?.querySelector('span');
		const variantHiddenInput = this.querySelector('input.product-variant-id');
		const stockStatus = this.getElement('stockStatus');

		// Check if strap size is selected
		//const strapSizeSelected = strapSizeInput.value && strapSizeInput.value.trim() !== '';

		// Check if variant is available
		const isVariantAvailable = variantHiddenInput &&
			!variantHiddenInput.hasAttribute('disabled') &&
			variantHiddenInput.value !== '';

		if (isVariantAvailable) {
			// Strap size selected and variant available - show "Add to Cart"
			if (submitButtonText) {
				submitButtonText.textContent = "Add to Cart";
			} else {
				productFormCTA.innerHTML = "<span>Add to Cart</span>";
			}
			productFormCTA?.removeAttribute('disabled');
			productFormCTA?.removeAttribute('aria-disabled');
			productFormCTA?.classList.remove('enquire-button-off');
			enquireButton?.classList.add('hidden');
			if (stockStatus) {
				stockStatus.classList.remove('not-available');
				stockStatus.classList.add('available');
			}
		} else {
			// Strap size selected but variant not available - show "Enquire"
			// if (submitButtonText) {
			// 	submitButtonText.textContent = "Enquire";
			// } else {
			// 	productFormCTA.innerHTML = "<span>Enquire</span>";
			// }
			productFormCTA?.setAttribute('disabled', 'disabled');
			productFormCTA?.setAttribute('aria-disabled', 'true');
			productFormCTA?.classList.add('enquire-button-off');
			enquireButton?.classList.remove('hidden');
			console.log('checkWatchStrapSizeButton');
			if (stockStatus) {
				stockStatus.classList.remove('available');
				stockStatus.classList.add('not-available');
			}
		}
	}




	accordionClickHandler() {
		const accordionHeaders = this.getElements('accordionToggles');
		accordionHeaders.forEach(accordionHeader => {
			accordionHeader.addEventListener('click', (e) => {
				e.preventDefault();
				const thisWrapper = accordionHeader?.parentNode;
				if (thisWrapper?.classList.contains('expanded')) {
					thisWrapper.classList.remove('expanded');
				} else {
					thisWrapper.classList.add('expanded');
				}
			})
		});
	}

	checkVariantSelected() {
		const selectedOptions = this.getElements('selectedOptions');
		let selectedVariantTitle = '';
		selectedOptions.forEach(selectedOption => {
			selectedVariantTitle += selectedOption.getAttribute('data-selected-option') + ' / '
		});
		let lastSlash = selectedVariantTitle.lastIndexOf(' / ');
		selectedVariantTitle = selectedVariantTitle.substring(0, lastSlash);
		this.getVariantId(selectedVariantTitle);
	}

	getVariantId(selectedVariantTitle) {
		const variantIdReference = this.getElement('variantIdSelectReference');
		const escapedTitle = selectedVariantTitle.replace(/"/g, '\\"');
		const selectedVariant = variantIdReference.querySelector(`[name="${escapedTitle}"]`);

		// Check if variant was found
		if (!selectedVariant) {
			console.warn('Variant not found for title:', selectedVariantTitle);
			return;
		}

		const selectedVariantAvailable = selectedVariant.getAttribute('data-available');
		const variantHiddenInput = this.getElement('variantHiddenInput');

		this.variantSelected = parseInt(selectedVariant.getAttribute('value'));
		variantIdReference.value = parseInt(selectedVariant.getAttribute('value'));


		if (selectedVariantAvailable == 'true') {
			this.updateAddToCartButton('true');
			this.updateAddToCartButton('true');
			variantHiddenInput.value = parseInt(selectedVariant.getAttribute('value'));
		} else {
			this.updateAddToCartButton('false');
			variantHiddenInput.value = '';
		}

		// Update specification accordion visibility based on selected variant
		this.updateSpecificationAccordion();

		// Check watch strap size button state after variant change
		this.checkWatchStrapSizeButton();

	}

	updateSpecificationAccordion() {
		if (!this.variantSelected) {
			return;
		}

		const accordionContentInner = this.querySelectorAll('.accordion-content__inner[data-variant]');
		accordionContentInner.forEach(element => {
			const variantId = parseInt(element.getAttribute('data-variant'));
			if (variantId === this.variantSelected) {
				element.classList.remove('hidden'); // Remove hidden class for matching variant
			} else {
				element.classList.add('hidden'); // Add hidden class for non-matching variants
			}
		});
	}

	updateAddToCartButton(status) {
		const productFormCTA = this.getElement('productFormCTA');
		const enquireButton = this.getElement('enquireButton');
		const stockStatus = this.getElement('stockStatus');
		const submitButtonText = productFormCTA?.querySelector('span');

		// Check if watch strap size is required
		const strapSizeInput = this.querySelector('.watch-strap-size-input');
		if (strapSizeInput) {
			// If strap size input exists, use the strap size check instead
			this.checkWatchStrapSizeButton();
			return;
		}

		if (status == 'true' || status === true) {
			if (submitButtonText) {
				submitButtonText.textContent = "Add to Cart";
			} else {
				productFormCTA.innerHTML = "<span>Add to Cart</span>";
			}
			productFormCTA?.removeAttribute('disabled');
			productFormCTA?.removeAttribute('aria-disabled');
			productFormCTA?.classList.remove('enquire-button-off');
			enquireButton?.classList.add('hidden');
			console.log('updateAddToCartButton');
			if (stockStatus) {
				stockStatus.classList.remove('not-available');
				stockStatus.classList.add('available');
			}

		} else {
			if (submitButtonText) {
				submitButtonText.textContent = "Enquire";
			} else {
				productFormCTA.innerHTML = "<span>Enquire</span>";
			}
			productFormCTA?.setAttribute('disabled', 'disabled');
			productFormCTA?.setAttribute('aria-disabled', 'true');
			productFormCTA?.classList.add('enquire-button-off');
			console.log('updateAddToCartButton');
			enquireButton?.classList.remove('hidden');
			if (stockStatus) {
				stockStatus.classList.remove('available');
				stockStatus.classList.add('not-available');
			}
		}
	}

	initSingleVariantProduct() {
		// Check if product has only 1 variant
		const variantSelector = this.querySelector('.main-pdp__variant-selector');
		if (variantSelector && variantSelector.classList.contains('hidden')) {
			// Product has only 1 variant, check availability and update button
			const variantHiddenInput = this.querySelector('input.product-variant-id');
			if (variantHiddenInput) {
				// Check if the input is disabled (variant not available)
				const isAvailable = !variantHiddenInput.hasAttribute('disabled') && variantHiddenInput.value !== '';

				// Update button based on availability
				if (isAvailable) {
					this.updateAddToCartButton('true');
				} else {
					this.updateAddToCartButton('false');
				}
			}
		}

		// Check watch strap size button state for single variant products
		this.checkWatchStrapSizeButton();
	}

	parseAccordionJSON() {
		// Find all accordion content areas
		const accordionContents = this.querySelectorAll('[data-accordion-content]');
		accordionContents.forEach(content => {
			const jsonScript = content.querySelector('script.accordion-json-data');
			if (jsonScript) {
				try {
					const jsonData = JSON.parse(jsonScript.textContent);
					let html = this.extractHTMLFromJSON(jsonData);
					if (html) {
						content.innerHTML = html;
					}
				} catch (e) {
					console.error('Error parsing accordion JSON:', e);
				}
			} else {
				const textContent = content.textContent.trim();
				if (textContent.startsWith('{') && textContent.includes('"type":"root"')) {
					try {
						const jsonData = JSON.parse(textContent);
						const html = this.extractHTMLFromJSON(jsonData);
						if (html) {
							content.innerHTML = html;
						}
					} catch (e) {
					}
				}
			}
		});
	}

	extractHTMLFromJSON(jsonData) {
		let html = '';
		if (jsonData.children) {
			jsonData.children.forEach(child => {
				if (child.children) {
					child.children.forEach(subchild => {
						if (subchild.value) {
							html += subchild.value;
						}
					});
				}
			});
		}
		return html;
	}

	initGalleryPagination() {
		if (window.innerWidth <= 991) {
			return;
		}

		const galleryPagination = this.querySelector('.gallery-dt-pagination');
		const mediaGallery = this.querySelector('.main-pdp__media-gallery');
		const mediaImages = this.querySelectorAll('.main-pdp__media-image');

		if (!galleryPagination || mediaImages.length === 0) {
			return;
		}

		const paginationBullets = galleryPagination.querySelectorAll('.pagination-bullet');

		if (paginationBullets.length === 0) {
			return;
		}

		// Get header and announcement bar heights
		const getHeaderOffset = () => {
			const header = document.querySelector('header, .header, .section-header');
			const announcementBar = document.querySelector('.announcement-bar, announcement-bar-slider');

			let headerHeight = 0;
			let announcementBarHeight = 0;

			if (header) {
				headerHeight = header.offsetHeight || 0;
			}

			if (announcementBar) {
				announcementBarHeight = announcementBar.offsetHeight || 0;
			}

			if (headerHeight === 0) {
				const headerHeightVar = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
				if (headerHeightVar) {
					headerHeight = parseFloat(headerHeightVar) || 0;
				}
			}

			// If still 0, use the 108px from CSS (100dvh - 108px calculation)
			if (headerHeight === 0 && announcementBarHeight === 0) {
				return 108;
			}

			return headerHeight + announcementBarHeight;
		};

		const updateActiveBullet = () => {
			const headerOffset = getHeaderOffset();
			const viewportHeight = window.innerHeight;

			const visibleTop = headerOffset;
			const visibleBottom = viewportHeight;
			const visibleCenter = visibleTop + (visibleBottom - visibleTop) / 1.5;

			let activeSlideIndex = null;
			let maxVisibility = 0;

			mediaImages.forEach((image) => {
				const slideIndex = image.getAttribute('data-slide-index');
				if (!slideIndex) return;

				const rect = image.getBoundingClientRect();

				const imageTop = rect.top;
				const imageBottom = rect.bottom;
				const imageCenter = rect.top + rect.height / 2;

				const visibleImageTop = Math.max(visibleTop, imageTop);
				const visibleImageBottom = Math.min(visibleBottom, imageBottom);
				const visibleHeight = Math.max(0, visibleImageBottom - visibleImageTop);

				const visibility = rect.height > 0 ? visibleHeight / rect.height : 0;

				const distanceFromCenter = Math.abs(imageCenter - visibleCenter);
				const normalizedDistance = distanceFromCenter / viewportHeight;
				const distanceScore = 1 / (1 + normalizedDistance);

				const score = visibility * 0.7 + distanceScore * 0.3;

				if (score > maxVisibility) {
					maxVisibility = score;
					activeSlideIndex = slideIndex;
				}
			});

			if (activeSlideIndex !== null) {
				paginationBullets.forEach((bullet) => {
					const bulletIndex = bullet.getAttribute('data-index');
					if (bulletIndex === activeSlideIndex) {
						bullet.classList.add('bullet-active');
					} else {
						bullet.classList.remove('bullet-active');
					}
				});
			}
		};

		// Function to scroll to a specific image
		const scrollToImage = (targetIndex) => {
			let targetImage = null;
			mediaImages.forEach((image) => {
				const slideIndex = image.getAttribute('data-slide-index');
				if (slideIndex === targetIndex) {
					targetImage = image;
				}
			});

			if (!targetImage) return;

			const headerOffset = getHeaderOffset();
			const rect = targetImage.getBoundingClientRect();
			const scrollY = window.scrollY || window.pageYOffset;

			const targetScrollY = scrollY + rect.top - headerOffset;

			// Smooth scroll to the target position
			window.scrollTo({
				top: targetScrollY,
				behavior: 'smooth'
			});
		};

		// Add click handlers to pagination bullets
		paginationBullets.forEach((bullet) => {
			bullet.addEventListener('click', (e) => {
				e.preventDefault();
				const bulletIndex = bullet.getAttribute('data-index');

				if (!bulletIndex) return;

				// Update bullet classes immediately for visual feedback
				paginationBullets.forEach((b) => {
					if (b === bullet) {
						b.classList.add('bullet-active');
					} else {
						b.classList.remove('bullet-active');
					}
				});

				// Scroll to the corresponding image
				scrollToImage(bulletIndex);
			});
		});

		// Function to toggle hidden class based on scroll position
		const updatePaginationVisibility = () => {
			if (!mediaGallery || !galleryPagination) return;

			const galleryRect = mediaGallery.getBoundingClientRect();
			const scrollY = window.scrollY || window.pageYOffset;
			const viewportHeight = window.innerHeight;

			const galleryBottom = scrollY + galleryRect.bottom;

			const viewportBottom = scrollY + (viewportHeight / 2);

			// Threshold: hide when we're within 100px of the bottom edge
			const threshold = 0;
			const distanceFromBottom = galleryBottom - viewportBottom;

			if (distanceFromBottom <= threshold) {
				galleryPagination.classList.add('hidden');
			} else {
				galleryPagination.classList.remove('hidden');
			}
		};

		// Throttle scroll events for performance
		let scrollTimeout;
		const handleScroll = () => {
			if (scrollTimeout) {
				cancelAnimationFrame(scrollTimeout);
			}
			scrollTimeout = requestAnimationFrame(() => {
				updateActiveBullet();
				updatePaginationVisibility();
			});
		};

		// Initial update
		updateActiveBullet();
		updatePaginationVisibility();

		// Listen to scroll events
		window.addEventListener('scroll', handleScroll, { passive: true });

		// Listen to resize events to recalculate on window resize
		let resizeTimeout;
		const handleResize = () => {
			if (resizeTimeout) {
				clearTimeout(resizeTimeout);
			}
			resizeTimeout = setTimeout(() => {
				if (window.innerWidth > 991) {
					updateActiveBullet();
					updatePaginationVisibility();
				}
			}, 250);
		};

		window.addEventListener('resize', handleResize);

		this._galleryPaginationCleanup = () => {
			window.removeEventListener('scroll', handleScroll);
			window.removeEventListener('resize', handleResize);
		};
	}

	disconnectedCallback() {
		if (this._galleryPaginationCleanup) {
			this._galleryPaginationCleanup();
			this._galleryPaginationCleanup = null;
		}
	}
}

if (!customElements.get('main-pdp')) {
	customElements.define('main-pdp', MainPDP);
}